import { useState, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import find from 'lodash/find';
import getGeneric from '../../../../../actions/getGeneric';

const useRecommendations = () => {
    const dispatch = useDispatch();
    const [selectedProperty, setSelectedProperty] = useState([]);
    const [prosConsData, setProsConsData] = useState(null);
    const [data, setData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [activeRecomendationType, setActiveRecomendationType] = useState(null);

    const storeData = useSelector(state =>
        get(state, 'filterReducer.config.ai_insights', [])
    );

    const propertyOptions = useMemo(() => {
        return get(find(storeData, { key: 'property_id' }), 'options', []);
    }, [storeData]);

    const isProsTabActive = useMemo(() => {
        return activeRecomendationType === 'pros';
    }, [activeRecomendationType]);

    useEffect(() => {
        if (propertyOptions.length > 0) {
            setSelectedProperty([propertyOptions[0]]);
        }
    }, [propertyOptions]);

    useEffect(() => {
        if (selectedProperty?.length) {
            fetchData(selectedProperty?.[0].value);
        }
    }, [selectedProperty]);

    function fetchData(property_id) {
        setIsLoading(true);
        setProsConsData(null);
        setActiveRecomendationType(null);
        dispatch(
            getGeneric({
                requestBody: {
                    data_tag: 'DATATAG_DELIGHTIQ_GET_PROPERTY_RECOMMENDATIONS',
                    request_data: {
                        property_id: property_id
                        // property_id: "MS9115"
                    }
                },
                onSuccess: e => {
                    setIsLoading(false);
                    let data = get(
                        e,
                        'api_response.APITAG_DELIGHTIQ_GET_PROPERTY_RECOMMENDATIONS',
                        {}
                    );
                    let prosCons = { pros: [], cons: [] };
                    try {
                        prosCons = data?.pros_cons ? JSON.parse(data?.pros_cons) : { pros: [], cons: [] };
                    } catch (error) {
                        console.log('Error parsing pros_cons:', error);
                        prosCons = { pros: [], cons: [] };
                    }

                    const parsedData = {
                        ...data,
                        pros_cons: prosCons
                    };
                    setData(parsedData);
                    setActiveRecomendationType('pros');
                    setProsConsData(get(parsedData, 'pros_cons.pros', []));
                },
                onError: e => {
                    setIsLoading(false);
                    console.log(e);
                }
            })
        );
    }

    function onProsConsButtonPress(type) {
        setActiveRecomendationType(type);
        setProsConsData(data?.pros_cons?.[type]);
    }

    return {
        selectedProperty,
        setSelectedProperty,
        propertyOptions,
        isLoading,
        data,
        prosConsData,
        activeRecomendationType,
        isProsTabActive,
        onProsConsButtonPress
    };
};

export default useRecommendations;
